import React from 'react';

import { Choice, Group, RadioChoice, Toggle } from './OptionControls';

/**
 * The budget risks and opportunities section's options: which items count,
 * how the summary groups them, how many of the largest are listed, and which
 * blocks the page shows.
 */
const BudgetRisksOptions = ({ options, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });
    const toggle = (key) => () => set({ [key]: !options[key] });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Scope')}>
                <RadioChoice
                    name="mp-budget-risks-scope"
                    label={$t('Scope')}
                    value={options.scope}
                    choices={[
                        { value: 'afc', label: $t('In AFC only') },
                        { value: 'all', label: $t('All with budget value') },
                    ]}
                    disabled={readOnly}
                    onChange={(scope) => set({ scope })}
                />
            </Group>
            <Group title={$t('Group by')}>
                <RadioChoice
                    name="mp-budget-risks-group-by"
                    label={$t('Group by')}
                    value={options.group_by}
                    choices={[
                        { value: 'department', label: $t('Department') },
                        { value: 'costcentre', label: $t('Cost centre') },
                    ]}
                    disabled={readOnly}
                    onChange={(groupBy) => set({ group_by: groupBy })}
                />
            </Group>
            <Group title={$t('Show')}>
                <Toggle
                    label={$t('Summary')}
                    hint={$t('Count, value, likelihood-weighted value, in AFC')}
                    checked={!!options.show_summary}
                    disabled={readOnly}
                    onChange={toggle('show_summary')}
                />
                <Toggle label={$t('Largest items')} checked={!!options.show_largest} disabled={readOnly} onChange={toggle('show_largest')} />
                <Choice
                    id="mp-budget-risks-largest"
                    label={$t('Items listed')}
                    value={options.largest}
                    choices={[5, 8, 10].map((count) => ({ value: count, label: String(count) }))}
                    disabled={readOnly || !options.show_largest}
                    onChange={(largest) => set({ largest })}
                />
                <Toggle
                    label={$t('Changes since prior period')}
                    hint={$t('New, closed, value or likelihood changed, moved in or out of AFC')}
                    checked={!!options.show_changes}
                    disabled={readOnly}
                    onChange={toggle('show_changes')}
                />
                <Toggle label={$t('Exposure vs contingency')} checked={!!options.show_exposure} disabled={readOnly} onChange={toggle('show_exposure')} />
            </Group>
        </div>
    );
};

export default BudgetRisksOptions;
